var map = {
	"./aberrant_spectre.png": 5416,
	"./abyssal_demon.png": 5729,
	"./adamant_dragon.png": 7590,
	"./ankou.png": 8950,
	"./araxyte.png": 8840,
	"./aviansie.png": 5252,
	"./bandit.png": 4034,
	"./banshee.png": 8126,
	"./banshees.png": 9447,
	"./basilisk.png": 712,
	"./bat.png": 2547,
	"./bear copy.png": 35,
	"./bear.png": 4650,
	"./black_demon.png": 3039,
	"./black_dragon.png": 2061,
	"./black_knight.png": 9235,
	"./bloodveld.png": 8821,
	"./blue_dragon.png": 4392,
	"./boss#boss_slayer.png": 4850,
	"./boss->boss_slayer.png": 6863,
	"./brine_rat.png": 8908,
	"./bronze_dragon.png": 5276,
	"./catablepon.png": 9223,
	"./cave_bug.png": 8932,
	"./cave_crawler.png": 8406,
	"./cave_horror.png": 9952,
	"./cave_kraken.png": 5042,
	"./cave_slime.png": 3162,
	"./chaeldar.png": 3314,
	"./chaos_druid.png": 2227,
	"./cockatrice.png": 2916,
	"./cow.png": 2451,
	"./crawling_hand.png": 379,
	"./crocodile.png": 970,
	"./dagannoth.png": 2426,
	"./dark_beast.png": 6200,
	"./dark_warrior.png": 6531,
	"./dog_slayer_task.png": 7467,
	"./drake.png": 1441,
	"./drakes.png": 1678,
	"./duradel.png": 6815,
	"./dust_devil.png": 8899,
	"./earth_warrior.png": 333,
	"./elves.png": 6297,
	"./ent.png": 3741,
	"./fever_spider.png": 538,
	"./fire_giant.png": 9730,
	"./flesh_crawler.png": 5749,
	"./fossil_island_wyvern.png": 4672,
	"./gargoyle.png": 1600,
	"./ghost.png": 4987,
	"./ghoul.png": 161,
	"./goblin.png": 7041,
	"./greater_demon.png": 3600,
	"./green_dragon.png": 8797,
	"./harpie_bug_swarm.png": 8859,
	"./hellhound.png": 7511,
	"./hill_giant.png": 1823,
	"./hobgoblin.png": 6132,
	"./hydra.png": 4922,
	"./ice_giant.png": 6665,
	"./ice_warrior.png": 8320,
	"./icefiend.png": 8513,
	"./infernal_mage.png": 9164,
	"./iron_dragon.png": 9110,
	"./jelly.png": 7226,
	"./jungle_horror.png": 7172,
	"./kalphite.png": 8556,
	"./killerwatt.png": 9389,
	"./konar_quo_maten.png": 6541,
	"./krystilia.png": 3114,
	"./kurask.png": 6341,
	"./lava_dragon.png": 726,
	"./lesser_demon.png": 5506,
	"./lesser_nagua.png": 7199,
	"./lizard.png": 832,
	"./lizardmen.png": 7278,
	"./magic_axe.png": 3718,
	"./mammoth.png": 4829,
	"./mazchna.png": 6376,
	"./minions_of_scabaras.png": 2170,
	"./minotaur.png": 9415,
	"./mithril_dragon.png": 547,
	"./mogre.png": 8898,
	"./molanisk.png": 9552,
	"./moss_giant.png": 6256,
	"./mutated_zygomite.png": 6123,
	"./nechryael.png": 8835,
	"./nieve.png": 3517,
	"./ogre.png": 4437,
	"./otherworldly_being.png": 4375,
	"./pirate.png": 4075,
	"./pyrefiend.png": 6802,
	"./rat.png": 6355,
	"./red_dragon.png": 845,
	"./revenant.png": 7405,
	"./rockslug.png": 9830,
	"./rogue.png": 5484,
	"./rune_dragon.png": 4680,
	"./scorpion.png": 8987,
	"./shadow_warrior.png": 7303,
	"./skeletal_wyvern.png": 7210,
	"./skeleton.png": 6977,
	"./slayer_task->banshees.png": 714,
	"./slayer_task->bats.png": 7925,
	"./slayer_task->bears.png": 8512,
	"./slayer_task->birds.png": 8069,
	"./slayer_task->dwarves.png": 4989,
	"./slayer_task->ghosts.png": 2033,
	"./slayer_task->goblins.png": 5593,
	"./slayer_task->kalphites.png": 2138,
	"./slayer_task->lizards.png": 9430,
	"./slayer_task->monkeys.png": 2839,
	"./slayer_task->rats.png": 5445,
	"./slayer_task->scorpions.png": 4643,
	"./slayer_task->skeletons.png": 6201,
	"./slayer_task->spiders.png": 1347,
	"./slayer_task->wolves.png": 8337,
	"./slayer_task->zombies.png": 5576,
	"./slayer_task:banshees.png": 9951,
	"./slayertask->banshees.png": 3687,
	"./smoke_devil.png": 5782,
	"./sourhog.png": 3749,
	"./spider.png": 3667,
	"./spiritual_creature.png": 6513,
	"./spria.png": 3813,
	"./steel_dragon.png": 1093,
	"./suqah.png": 4740,
	"./troll.png": 4735,
	"./turael.png": 3165,
	"./turoth.png": 8080,
	"./tzhaar.png": 3890,
	"./vampyre.png": 3476,
	"./vannaka.png": 8550,
	"./wall_beast.png": 8504,
	"./warped_creature.png": 9213,
	"./waterfiend.png": 4049,
	"./wolf.png": 5200,
	"./wyrm.png": 4427,
	"./zombie.png": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;